import { render, staticRenderFns } from "./GenerateDataTemplate.vue?vue&type=template&id=143524af&lang=pug"
import script from "./GenerateDataTemplate.vue?vue&type=script&lang=js"
export * from "./GenerateDataTemplate.vue?vue&type=script&lang=js"
import style0 from "./GenerateDataTemplate.vue?vue&type=style&index=0&id=143524af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports